import FieldConfig from "../../../proto/field-config";
import FieldNumber from "../../../generic/number/number";
import ItemModel from "../../../../model2/item/item-model";
import TableManager from "../../../../gd-modules/table/manager/table-manager";
import TaskListManager from "../../../../gd-modules/task-list/manager/manager";
import {LifecycleAction} from "../../../../gd/const/lifecycle";
import Project from "../../../../model2/project/project";
import {ViewType} from "../../../../gd/const/views/view-type";
import GanttChartManager from "../../../../gd-modules/gantt-chart/manager/manager";

export default class FieldProjectDurationWorkdays extends FieldNumber {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-age'
        this.label              = 'Duration work days'

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    canEdit(model:Project):boolean {
        return model.acl.canChangeDuration
    }

    tableCellOnValueChange = async (item:ItemModel, value: number, manager: TableManager|TaskListManager|GanttChartManager) => {
        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:
                const ganttManager = manager as GanttChartManager
                ganttManager.updateFieldManager2.setWorkDuration(item.id, value)
                break

            default:
                item.project.durationWorkdays = value
                item.project.save()

                item._updateLastUpdateTime() // otherwise it wont re-render

                manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])
                break
        }
    }

}
